export default __webpack_public_path__ + "static/contact-6a3a646813affb5a46eed0c78086e10c.png";